/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import GroupProperties, {getWebMapId} from '@ion/core/src/services/GroupProperties';
import {globalGroupIdSelector} from '@/store/selectors/global-group-chooser-selectors';

/**
 * Retrieves the Web Map ID for the currently selected global group.
 *
 * Whenever the global group changes, the hook loads the inherited group
 * properties for that account and updates the Web Map ID accordingly.
 */
const useWebMapId = () => {
  const globalGroupId           = useSelector(globalGroupIdSelector);
  const [webMapId, setWebMapId] = useState<string>();

  useEffect(() => {
    const loadWebMapId = async() => {
      await GroupProperties.getInheritedProperties(globalGroupId);
      setWebMapId(getWebMapId());
    };

    if (globalGroupId) {
      loadWebMapId();
    }
  }, [globalGroupId]);

  return webMapId;
};

export default useWebMapId;
